import axios from 'axios'

const getMethod = async (url: string, headers:any) => {
    //axios.defaults.withCredentials = true;
    let response = await axios.get(url,headers)
    .then(function (response) {
        return response;
    })
    .catch((error) => { console.error(error); throw error; })
    return response;
}

const postMethod = async (url: string, params:any, headers:any) => {
    //.defaults.withCredentials = true;
    let response = await axios.post(url,params,headers)
    .then(function (response) {
        return response;
    })
    .catch((error) => { console.error(error); throw error; })
    return response;
}

const putMethod = async (url: string, params:any, headers:any) => {
    //axios.defaults.withCredentials = true;
    let response = await axios.put(url,params,headers)
    .then(function (response) {
        return response;
    })
    .catch((error) => { console.error(error); throw error; })
    return response;
}

const deleteMethod = async (url: string, headers:any) => {
    //axios.defaults.withCredentials = true;
    let response = await axios.delete(url,headers)
    .then(function (response) {
        return response;
    })
    .catch((error) => { console.error(error); throw error; })
    return response;
}

export {getMethod, postMethod, putMethod, deleteMethod}